import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { EstadoCuentaInformacionService } from "../../servicios/estado-cuenta-informacion.service";
import { ActivatedRoute, Router } from "@angular/router";
import { MuestraMensaje } from "../../shared/utilerias/notificaciones/notificaciones.component";
import { AguaBloqueosService } from "../../servicios/agua-bloqueos.service";
import {
  EstadoCuentaInformacion,
  EstadoCuentaInformacionInput,
  AuxJasper,
  ParametroJasper,
  AguaBloqueos,
} from "../../entidades/entidades";

import { execDbService } from 'app/servicios/exec-db.service';
var $: any;


@Component({
  selector: 'app-estado-cuenta-informacion-online',
  templateUrl: './estado-cuenta-informacion-online.component.html',
  styleUrls: ['./estado-cuenta-informacion-online.component.css']
})
export class EstadoCuentaInformacionOnlineComponent implements OnInit {
 
  public jasperInputCatTipoDoc$ = new EventEmitter<AuxJasper>();
  public auxJasper: AuxJasper;
  muestraMensaje = new MuestraMensaje();
  estadoCuentaInformacionForm: FormGroup;
  public fechaVencimiento:Date;
  display: boolean = false;
  showDialog() {
    this.display = true;
  }

  bandera: boolean = false;
  @Input("edoAdeudo") edoAdeudo: boolean = false;
  @Input("LicAdeudo") LicAdeudo: boolean = false;
  @Input("HisAduedo") HisAduedo: boolean = false;

  public aguaBloqueos: AguaBloqueos[];
  public aguaBloq: AguaBloqueos;

  @Input("estadoCuentaInformacionInput") estadoCuentaInformacionInput: EstadoCuentaInformacionInput;
  @Output("estadoCuentaInformacionOutput") estadoCuentaInformacionOutput: EventEmitter<EstadoCuentaInformacion>;

  estadoCuentaTable: any;
  public idAgua: number;
  constructor(
    private formBuilder: FormBuilder,
    private estadoCuentaInformacionService: EstadoCuentaInformacionService,
    private router: Router,
    private route: ActivatedRoute,
    private aguaBloqueosService: AguaBloqueosService,
    private execDbService: execDbService
  ) {
    this.estadoCuentaInformacionOutput = new EventEmitter()
  }
  ngOnInit() {
    this.estadoCuentaInformacionForm = this.formBuilder.group({
      idAgua: [undefined],
      cuentaAgua: [undefined, [Validators.pattern(/^[0-9]+\.?[0-9]*$/)]],
      cuentaAnterior: [undefined],
      nombreCompleto: [undefined],
      domicilio: [undefined],
      cp: [undefined],
      ruta: [undefined, [Validators.pattern(/^[0-9]+\.?[0-9]*$/)]],
      numeroMedidor: [undefined],
      fechaInstalacion: [undefined],
      claveCatastral: [undefined],
      rfc: [undefined],
      periodo: [undefined, [Validators.pattern(/^[0-9]+\.?[0-9]*$/)]],
      tipoPeriodo: [undefined],
      anio: [undefined, [Validators.pattern(/^[0-9]+\.?[0-9]*$/)]],
      fechaVencimiento: [undefined],
      derivada: [undefined, [Validators.pattern(/^[0-9]+\.?[0-9]*$/)]],
      anomalia: [undefined],
      observaciones: [undefined],
      diametro: [undefined],
      tipoServicio: [undefined],
      proximaLectura: [undefined],
      tipoUso: [undefined],
      lecturaIni: [undefined, [Validators.pattern(/^[0-9]+\.?[0-9]*$/)]],
      lecturaFin: [undefined, [Validators.pattern(/^[0-9]+\.?[0-9]*$/)]],
      periodoConsumoIni: [undefined],
      periodoConsumoFin: [undefined],
      consumo: [undefined, [Validators.pattern(/^[0-9]+\.?[0-9]*$/)]],
      total: [undefined, [Validators.pattern(/^[0-9]+\.?[0-9]*$/)]],
      periodoadeudo: [undefined],
      // fechaAlta: [undefined],
      // fechaBaja: [undefined],
      // idEstatus: [undefined],
      // esCumplido: [undefined]
    });
    // if (this.estadoCuentaInformacionInput) this.estadoCuentaInformacionForm.patchValue(this.estadoCuentaInformacionInput);
    // if (this.estadoCuentaInformacionInput) {
    //   this.getEstadoCuentaInformacionAll(this.estadoCuentaInformacionInput);
    //   debugger;
    // }

  }
  ngOnChanges() {
    if (this.estadoCuentaInformacionInput) {
      this.getEstadoCuentaInformacionAll(this.estadoCuentaInformacionInput);
    }
  }

  //====================================================
  //Metodos para obtener datos del servicio
  //====================================================
  async getEstadoCuentaInformacionAll(estadoCuentaInformacionInput: EstadoCuentaInformacionInput) {
    try {
      const datoRetorno = await this.estadoCuentaInformacionService
        .getBusquedas(estadoCuentaInformacionInput)
        .toPromise();
       
      console.log("Detalle informacion", datoRetorno);
      this.estadoCuentaInformacionForm.patchValue(datoRetorno[0]);
      this.estadoCuentaTable = datoRetorno;
      
      if (datoRetorno[0].fechaVencimiento){
        this.fechaVencimiento = datoRetorno[0].fechaVencimiento.toLocaleString().split('T')[0];
      }
      console.log('Tabla --->', this.estadoCuentaTable);

      /* Validacion que muestra un mensaje cuando la cuenta esta bloqueada */
      if (datoRetorno[0].bloqueoVigente != null    )  {
          const inputJson = { "id_operacion": 1, "id_agua": this.idAgua };
          const datoRetorno = await this.execDbService.processJsonData(inputJson).toPromise();
          if (!datoRetorno.data[0].cobra) 
            {
              this.muestraMensaje.error("Esta cuenta está bloqueada", "top", "center");
              this.estadoCuentaInformacionForm.reset();
              console.log("bloqueado")
            }

      }
      /* Validacion que muestra un mensaje cuando la cuenta esta cancelada */
      else if (datoRetorno[0].estatus == "CANCELADO") {
        this.muestraMensaje.error("Esta cuenta está cancelada", "top", "center");
        console.log("cancelada")
      }

      if (this.estadoCuentaTable[0].proximaLectura != "") {
        //Conversion del formato de fecha
        let aux = this.estadoCuentaTable[0].proximaLectura;
        let fechaSeparada = aux.split(' ');
        let fechaSeparada1 = fechaSeparada[0].split('-');
        let fechaSeparada2 = fechaSeparada[2].split('-');
        let fechaFinal = fechaSeparada1[2] + '-' + fechaSeparada1[1] + '-' + fechaSeparada1[0] + ' ' + fechaSeparada2[2]
          + '-' + fechaSeparada1[1] + '-' + fechaSeparada1[0];
        this.estadoCuentaTable[0].proximaLectura = fechaFinal;
      }

      if (this.estadoCuentaTable[0].periodoadeudo != null) {
        //Conversion del formato de fecha (Periodo Consumo)
        console.log(this.estadoCuentaTable[0].periodoadeudo);
        let aux = this.estadoCuentaTable[0].periodoadeudo;
        let fechaSeparada = aux.split(' ');
        let fechaSeparada1 = fechaSeparada[0].split('-');
        let fechaSeparada2 = fechaSeparada[2].split('-');
        let bimestre = "BIM";
        let fechaFinal = bimestre + '-' + fechaSeparada1[2] + '-' + fechaSeparada1[1] + ' ' + fechaSeparada[1] + ' '
          + bimestre + '-' + fechaSeparada2[2] + '-' + fechaSeparada2[1];
        this.estadoCuentaTable[0].periodoadeudo = fechaFinal;
      }
      console.log('Tabla --->', this.estadoCuentaTable);

      this.idAgua = datoRetorno[0].idAgua;
      this.bandera = true;

      this.aguaBloq = new AguaBloqueos();
      this.aguaBloq.idAgua = datoRetorno[0].idAgua;
      this.getAllAguaBloqueos(this.aguaBloq);

    } catch (e) {
      if (e.response) {
        throw { message: e.response.data };
      } else {
        throw e;
      }
    } finally {
      console.log("Paso por getEstadoCuentaInformacionAll");
    }
  }

  async getEstadoCuentaInformacion(id: number) {
    try {
      const datoRetorno = await this.estadoCuentaInformacionService
        .getSingle(id)
        .toPromise();
      this.estadoCuentaInformacionForm.patchValue(datoRetorno);

    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getEstadoCuentaInformacion");
    }
  }

  async getAllEstadoCuentaInformacion() {
    try {
      const datoRetorno = await this.estadoCuentaInformacionService.getAll().toPromise();
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getAllEstadoCuentaInformacion");
    }
  }
  async imprimir() {
    try {
      console.log("imprimir", this.idAgua);
      //ejemplo de llamada de reporte.
      this.auxJasper = new AuxJasper();
      this.auxJasper.JasperReport.nombreReporte = "EstadoDeCuenta";
      this.auxJasper.JasperReport.tipo = "pdf";
      let _id_agua = new ParametroJasper();
      _id_agua.nombre = "_id_agua";
      _id_agua.valor = this.idAgua + "";
      console.log("parametro", _id_agua.valor);
      await this.auxJasper.ParametroJasper.push(_id_agua);

      //await $(".solicitud").modal("show"); //Para mostrar en forma de Poppup
      //this.router.navigateByUrl("componentes/visor", { state: this.auxJasper.JasperReport }); //Para mostrarlo con pagina independiente
      this.showDialog();

    } catch (error) {
      if (error.response) throw { message: error.response.data };
      else throw error;
    }
  }
  async imprimirLiquidacion() {
    try {
      console.log("imprimirLiquidacion", this.idAgua);
      //ejemplo de llamada de reporte.
      this.auxJasper = new AuxJasper();
      this.auxJasper.JasperReport.nombreReporte = "liquidacion";
      this.auxJasper.JasperReport.tipo = "pdf";
      this.auxJasper.JasperReport.imprimir = false;
      let _id_agua = new ParametroJasper();
      _id_agua.nombre = "_id_agua";
      _id_agua.valor = this.idAgua + "";
      console.log("parametro", _id_agua.valor);
      await this.auxJasper.ParametroJasper.push(_id_agua);

      //await $(".solicitud").modal("show"); //Para mostrar en forma de Poppup
      //this.router.navigateByUrl("componentes/visor", { state: this.auxJasper.JasperReport }); //Para mostrarlo con pagina independiente
      this.showDialog();

    } catch (error) {
      if (error.response) throw { message: error.response.data };
      else throw error;
    }

  }
  async HistoricoAduedo() {
    try {
      console.log('idAgua: ', this.idAgua)
      this.router.navigate(['componentes/historico-adeudos'],
        {
          state: { example: this.idAgua }
        });

    } catch (error) {
      if (error.response) throw { message: error.reposnse.data };
      else throw error
    }
  }
  async getAllAguaBloqueos(aguaBloqueos: AguaBloqueos) {
    try {
      const datoRetorno = await this.aguaBloqueosService.getSingle(aguaBloqueos.idAgua).toPromise();
      this.aguaBloqueos = datoRetorno;
      console.log('Datos:', this.aguaBloqueos);
      if (aguaBloqueos[0] != null) {
        console.log('Tiene bloqueo');
      }
      else {
        console.log('No tiene bloqueo');

      }
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getAllAguaBloqueos");
    }
  }
  AbreDatosParaPagar(){

  }

}
